"use client";
import React from "react";
import { Template } from "@/types/models/template";

interface TemplateInfoCardProps {
  template: Template;
}

export const TemplateInfoCard: React.FC<TemplateInfoCardProps> = ({
  template,
}) => {
  return (
    <div
      className="bg-card dark:bg-auth-card rounded-xl border border-border dark:border-auth-background shadow-sm mb-8 animate-fadeInUp"
      style={{ animationDelay: "0.1s" }}
    >
      <div className="p-6">
        <h3 className="text-lg font-semibold text-foreground mb-2">
          {template.name}
        </h3>
        <p className="text-muted-foreground mb-4">{template.description}</p>
        <div className="text-sm text-muted-foreground">
          Select the pages you want to import into your store
        </div>
      </div>
    </div>
  );
};
